<app-data-state class="block h-full" [loading]="loading$ | async" [error]="error$ | async">
  <div class="flex flex-col h-full">
    <div
      *ngIf="behaviorSummaryHtml"
      class="markdown-content prose prose-lg max-w-none"
      [innerHTML]="behaviorSummaryHtml"
    ></div>
    <div *ngIf="!behaviorSummaryHtml && descriptionItems.length" class="p-fluid">
      <div class="flex flex-col gap-1">
        <ul class="list-none pl-0 mt-0 mb-0">
          <li
            *ngFor="let item of descriptionItems"
            class="flex items-center gap-[10px] py-3 border-b border-[#eee] transition-all duration-200 ease-in-out last:border-b-0"
          >
            <div
              class="w-[30px] h-[30px] flex items-center justify-center rounded-full bg-[#e8fded] text-[color:var(--color-bon)] shrink-0"
            >
              <i-lucide
                name="corner-down-right"
                class="mt-icon"
                [size]="18"
              ></i-lucide>
            </div>
            <div>{{ item }}.</div>
          </li>
        </ul>
      </div>
    </div>
    <div *ngIf="!behaviorSummaryHtml && !descriptionItems.length" class="flex items-center justify-center min-h-[25vh]">
      <app-no-data></app-no-data>
    </div>
  </div>
</app-data-state>
